export default async function *combineAsyncIterables<T>(
    getNumber: (object: T) => number,
    // Currently only 'desc' ordering is supported
    order: 'desc',
    ...iterables: AsyncIterable<T>[]
): AsyncIterableIterator<T> {

    const iterators = iterables.map(iterable => iterable[Symbol.asyncIterator]());
    const results = await Promise.all(iterators.map(iterator => iterator.next()));
    const prevResults = [];

    while (true) {
        const index = maxIndexBy(
            results,
            result => result.done ? undefined : getNumber(result.value)
        );

        if (index === -1) break;
        yield results[index].value;

        prevResults[index] = results[index];
        results[index] = await iterators[index].next();

        if (
            !results[index].done &&
            getNumber(results[index].value) > getNumber(prevResults[index].value)
        ) {
            throw new Error('Source data not sorted!');
        }
    }
}

function maxIndexBy<T>(collection: T[], getNumber: (t: T) => number | undefined) {
    let maxIndex = -1;
    let maxValue;

    for (let index = 0; index < collection.length; index++) {
        const value = getNumber(collection[index]);
        if (value !== undefined && (maxValue === undefined || value > maxValue)) {
            maxIndex = index;
            maxValue = value;
        }
    }

    return maxIndex;
}
